import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {TUTORIAL_ROUTES} from 'constants/TutorialConstants';

export default function ImportFilesTutorialLink(): JSX.Element | null {
  // Hide tutorial link for enterprise deploys.
  if (BenchlingConfig.PRIVATE_DEPLOY) {
    return null;
  }
  return (
    <span className="u-btn-af-height">
      Need help?&nbsp;
      <a href={TUTORIAL_ROUTES.REGISTRY_IMPORT_SPREADSHEETS} target="_blank" rel="noopener noreferrer">
        Check out our tutorial
      </a>
      .
    </span>
  );
}
